import { createFileRoute } from '@tanstack/react-router'
import { ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { DnsTool, isRecordType } from '@/components/tool-page/dns-tool'
import { TOOLS } from '@/lib/tool-content'

const content = TOOLS['dns-propagation-checker']

export const Route = createFileRoute('/_site/tools/dns-propagation-checker')({
  component: DnsPropagationCheckerPage,
  validateSearch: (search: Record<string, unknown>): { q?: string; type?: string } => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
    type: typeof search.type === 'string' && search.type ? search.type : undefined,
  }),
  head: () => toolHead(content),
})

function DnsPropagationCheckerPage() {
  const { q, type } = Route.useSearch()
  const upper = type?.toUpperCase()
  return (
    <ToolPage content={content}>
      <DnsTool content={content} initialName={q ?? ''} initialType={isRecordType(upper) ? upper : 'A'} autoRun={!!q} />
    </ToolPage>
  )
}
